import { useQuery } from 'react-query';

import { QUERY_KEYS } from 'consts/queryKeys';
import { getCities } from 'modules/settings/api';

export const useQueryCities = () => {
  const {
    data: citiesData,
    isLoading: citiesLoading,
    isError: citiesError,
  } = useQuery([QUERY_KEYS.RENTALS_CITIES], getCities, {
    staleTime: 5 * 60 * 1000,
    keepPreviousData: true,
  });

  return { citiesData, citiesLoading, citiesError };
};
